const ENDPOINT = `${process.env.REACT_APP_BACKEND_URL}/api/client-log`;

export function logClientError(payload) {
  try {
    const body = JSON.stringify({
      url: typeof window !== "undefined" ? window.location.href : "",
      ua: typeof navigator !== "undefined" ? navigator.userAgent : "",
      ...payload,
    });
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
    } else {
      fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (e) {
    /* best-effort only */
  }
}

export function installGlobalErrorLogging() {
  if (typeof window === "undefined") return;
  window.addEventListener("error", (e) => {
    logClientError({
      source: "window.onerror",
      message: (e && (e.message || String(e.error || "error"))) || "error",
      stack: (e && e.error && e.error.stack) || "",
    });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e && e.reason;
    logClientError({
      source: "unhandledrejection",
      message: (r && (r.message || String(r))) || "unhandledrejection",
      stack: (r && r.stack) || "",
    });
  });
}
